var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPfeilDropdownRunter02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Pfeil-Dropdown-runter-02__Icn/40px/Pfeil-Dropdown-runter-02",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Pfeil-Dropdown-runter-02__Icn/20px/Icon-Platzhalter-Transparent",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Pfeil-Dropdown-runter-02__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Icn_40px_Pfeil-Dropdown-runter-02__Triangle",
    transform: "matrix(1 0 0 -1 0 42)",
    d: "M20.5 15 27 27 14 27z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfeilDropdownRunter02);
export default __webpack_public_path__ + "static/media/Pfeil-Dropdown-runter-02.d5af0e83babbd819ba4e109e815ff28a.svg";
export { ForwardRef as ReactComponent };